<template lang="pug">
.form-room-customers
  .with-actions
    h2 房客信息
    .ui.buttons.actions.hide-in-mobile
      .ui.basic.icon.button(@click='dialog_customers_visible = true')
        i.icon.pencil.themed.text
  auto-edit-table(:defines='$defines.customer', unstackable, :data='customers', :button-add='false',
    :actions='get_customer_actions',
    @action:card_checkin='native_invoke_checkin',
    @action:right:card_checkin='c => form_add_card(c)',
    @action:card_extension='native_invoke_extension',
    @action:card_supplement='native_invoke_supplement',
    @action:card_checkout='native_invoke_checkout',
    @action:kitchen_new='native_invoke_kitchen_new',
    @action:right:card_checkout='c => form_remove_card(c)',
  )
  dialog-customers(:visible.sync='dialog_customers_visible', :contract='contract', @exit='customer_dialog_exit')

  promise-dialog(ref='dialog_making', title='发卡中...')
    p 请等待系统完成发卡操作

  el-dialog(:visible.sync='dialog_idcard_verify', :title='dialog_idcard_verify_title')
    p 请将身份证放置于身份证读卡器上

    div(slot='footer')
      .ui.button(@click='dialog_idcard_verify_cancel') 取消
      .ui.button.orange(@click='dialog_idcard_verify_skip', v-if='$permission.has("native.cards.skip_vertify")') 跳过验证
</template>

<script>
import { MakeForm } from '../../utils'
import { AutoEditTable } from '../auto'
import { PromiseDialog } from '../basic'
import DialogCustomers from './DialogCustomers.vue'

export default {
  name: 'form-room-customers',
  components: {
    AutoEditTable,
    DialogCustomers,
    PromiseDialog,
  },
  props: {
    no: String,
    contract: null,
    customers: Array,
  },
  data() {
    return {
      dialog_customers_visible: false,
      dialog_idcard_verify: false,
      dialog_idcard_verify_title: '验证身份证',
      dialog_idcard_verify_cancel() { },
      dialog_idcard_verify_skip() { },
    }
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    date_expire() {
      return this.$moment((this.contract || {}).date_expire).startOf('days')
    },
    date_today() {
      return this.$moment().startOf('days')
    },
    days_to_expired() {
      if (this.contract)
        return this.$moment.daysBetween(this.date_expire, this.date_today)
      return 0
    },
  },
  methods: {
    get_customer_cards(customer) {
      return (customer.room_cards || []).filter(c => c.room_no === this.no)
    },
    get_customer_actions(customer) {
      // TODO: filter from customer state
      let actions = ['edit']

      if (this.$native.supported) {
        const cards = this.get_customer_cards(customer)
        if (cards.length >= 1) {
          actions = ['card_extension', 'card_supplement', 'card_checkout'].concat(actions)
          actions.unshift({
            text: `${cards.length} 张卡`,
            classes: 'teal',
          })
        } else
          actions.unshift('card_checkin')
        actions.push('kitchen_new')
      }
      return actions
    },
    customer_dialog_exit(customers) {
      if (customers) {
        this.$store.dispatch('load_customers')
        this.contract._customers = customers
      }
    },
    form_add_card(customer, useNative = false) {
      return MakeForm({
        url: `customers/${customer._id}/cards`,
        type: 'post',
        confirm: useNative ? null : '确定要添加补发记录吗？（将不会调用发卡系统）',
        payload: () => ({
          room_no: this.no,
          time_start: this.date_today,
          time_end: this.date_expire,
          enabled: true,
        }),
        $afterSuccess: () => {
          this.$store.dispatch('load_customers')
        },
      }).apply(this)
    },
    form_remove_card(customer, index = 0, useNative = false) {
      const cards = this.get_customer_cards(customer)
      const card = cards[index]
      if (!card || !card._id)
        return
      return MakeForm({
        url: `customers/${customer._id}/cards/${card._id}`,
        type: 'delete',
        confirm: useNative ? null : '确定要删除卡片记录吗？（将不会调用发卡系统）',
        $afterSuccess: () => {
          this.$store.dispatch('load_customers')
        },
      }).apply(this)
    },
    form_kitchen_new(customer) {
      // TODO:
    },
    native_make_command(type, customer) {
      return `autoit cards ${type} ${this.no} ${customer.name} ${customer.idcard} ${customer.phone1} ${this.days_to_expired}`
    },
    /* eslint-disable no-new */
    native_invoke(message) {
      return this.$refs.dialog_making.invoke_and_show(message)
        .then((response) => {
          new Notification({
            title: '成功',
            message: '操作成功',
            type: 'success',
          })
          return response
        })
        .catch((error) => {
          new Notification({
            title: '失败',
            error,
            type: 'error',
          })
          throw (error)
        })
    },
    /* eslint-enable no-new */
    native_idcard_vertify_cancel() {
      this.dialog_idcard_verify = false
    },
    native_idcard_vertify_skip() {
      this.dialog_idcard_verify = false
    },
    native_idcard_vertify(customer) {
      return new Promise((reslove, reject) => {
        let canceled = false
        this.dialog_idcard_verify = true
        this.dialog_idcard_verify_title = `验证身份证 - ${customer.name}`
        this.dialog_idcard_verify_cancel = () => {
          canceled = true
          this.dialog_idcard_verify = false
          reject()
        }
        this.dialog_idcard_verify_skip = () => {
          canceled = true
          this.dialog_idcard_verify = false
          reslove()
        }
        this.$native.invoke('idcard', (response) => {
          if (canceled)
            return
          if (!response || (response.text || '').startsWith('$error')) {
            this.$alert(`读取失败 - ${this.$formatters.native_error_message((response || {}).text)}`)
            reject(response || {})
          } else if (response.name !== customer.name) {
            this.$alert(`身份证信息不匹配（${customer.name} - ${response.name}）！请重试。`)
            reject(response || {})
          } else if (response.id !== customer.idcard) {
            this.$alert('身份证号不匹配！请重试。')
            reject(response || {})
          } else if (this.dialog_idcard_verify)
            reslove(response)
          else
            reject(response || {})
          this.dialog_idcard_verify = false
        })
      })
    },
    native_invoke_checkin(customer) {
      if (this.days_to_expired > 0) {
        this.native_idcard_vertify(customer)
          .then(() => {
            this.native_invoke(this.native_make_command('checkin', customer))
              .then(response => {
                if (response)
                  this.form_add_card(customer, true)
              })
          })
          .catch()
      }
    },
    native_invoke_extension(customer) {
      if (this.days_to_expired > 0) {
        this.$confirm('确认续住房卡至当前租金截止日？\n请将房卡放置于房卡读卡器上后继续。')
          .then(() => {
            this.native_invoke(this.native_make_command('extension', customer))
          })
          .catch()
      }
    },
    native_invoke_supplement(customer) {
      if (this.days_to_expired > 0) {
        this.native_idcard_vertify(customer)
          .then(() => {
            this.native_invoke(this.native_make_command('supplement', customer))
          })
          .catch()
      }
    },
    native_invoke_checkout(customer) {
      this.$confirm('确认退卡？\n请将房卡放置于房卡读卡器上后继续。')
        .then(() => {
          this.native_invoke(this.native_make_command('checkout', customer))
            .then(response => {
              if (response)
                this.form_remove_card(customer, 0, true)
            })
        })
        .catch()
    },
    native_invoke_kitchen_new(customer, charges = 0) {
      this.$confirm('确定发行厨房卡？\n请将厨房电卡插入读卡器后继续。')
        .then(() => {
          this.native_invoke(`autoit kitchen create ${this.no} ${customer.name} ${customer.phone1} ${charges}`)
            .then(response => {
              if (response)
                this.form_kitchen_new(customer)
            })
        })
        .catch()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormRoomCustomers.vue?58325b43